import { Sorter, RemoteSort } from './sorter.class';
import { AbstractTable, TableArgs, IAbstractCol, ColsArgs } from '../abstract/table.class';
import { Chain } from '../../chain.class';
import { RemoteMenu } from './menu/menu.component';
import { PaginatorArgs } from '../../../../utils/viewport';


export interface RemoteCol<D extends object> extends IAbstractCol<D> {
   sorterMark?: string;
}


export interface LocalColArgs<D extends object> extends ColsArgs<D> {
   templates: {
      [id: string]: RemoteCol<D>;
   }
}

export interface RemoteTableArgs<D extends object> extends TableArgs<D> {
   sort: RemoteSort<D>;
   paginator: PaginatorArgs;
   cols: LocalColArgs<D>;
}


export class RemoteTable<D extends object> extends AbstractTable<D> {
   readonly chain: Chain<D>;
   readonly sorter: Sorter<D>;
   readonly menu: RemoteMenu;

   constructor(args: RemoteTableArgs<D>) {
      super(args);
      this.sorter = new Sorter(this, args.sort);
      this.menu = new RemoteMenu(this);
      this.viewport.setPaginator(args.paginator);
      this.chain = new Chain({
         isAlive: this.dom.isAlive,
         source: this.source,
         rings: [ this.selection, this.rows]
      });
   }
}
